import type { EmbeddedBrowserCookieImportResult } from "../electronAPIs/browser"

type BrowserCookieImportMessageResult = Pick<EmbeddedBrowserCookieImportResult, "requested" | "imported" | "skipped" | "warnings" | "partial" | "firstErrors"> &
    Partial<Pick<EmbeddedBrowserCookieImportResult, "retiredPartitionCleared">>

export function browserCookieImportMessage(result: BrowserCookieImportMessageResult | null): string {
    if (!result) return "Website sessions could not be imported. The source browser may use protected cookie storage."
    if (result.retiredPartitionCleared === false) {
        return "Website sessions were imported into a fresh Browser profile, but the previous profile could not be fully deleted. Restart WildLark and try deleting Browser data."
    }
    if (result.requested === 0 && result.warnings > 0) {
        return "Website sessions could not be read from the selected profile. The current WildLark Browser profile was kept."
    }
    if (result.requested === 0) return "No current website sessions were found; WildLark Browser now uses a fresh signed-out profile."
    if (result.imported === 0) {
        return `None of the ${result.skipped.toLocaleString()} cookies could be copied. The current WildLark Browser profile was kept.`
    }
    if (result.partial) {
        return `Replaced the Browser profile and imported ${result.imported.toLocaleString()} of ${result.requested.toLocaleString()} cookies. Some protected cookies could not be copied.`
    }
    return `Imported ${result.imported.toLocaleString()} cookies into a fresh Browser profile.`
}
